'use client';

// eslint-disable-next-line no-restricted-imports
import { usePathname, useSearchParams } from 'next/navigation';

import { IPath } from '@/types/IPath';

export const useAppPath = () => {
  const pathname = usePathname() as IPath;
  const searchParams = useSearchParams();

  const queryString = searchParams.toString();
  const pathnameWithQueryParams = queryString ? `${pathname}?${queryString}` : pathname;

  return { pathname, pathnameWithQueryParams };
};
